import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export const VerifyReminder = ({ className = "" }) => (
  <p className={`flex items-start gap-1.5 text-xs text-slate-500 ${className}`} data-testid="verify-reminder">
    <ShieldAlert size={14} className="mt-px shrink-0" />
    <span>We strive to get it right, but sometimes we get it wrong. Please check important information for yourself before relying on it. <Link to="/terms" className="underline" data-testid="verify-reminder-terms-link">Terms of Use</Link></span>
  </p>
);
